import axios from 'axios';
import { MENU_FILTERS_ENDPOINT, RESTRICTION_INTERVAL_ENDPOINT } from '@dynameat/constants';

export const menuFilterListRequest = (pointOfSaleGuid) => axios.get(MENU_FILTERS_ENDPOINT(), { params: { point_of_sale__guid: pointOfSaleGuid } });
export const restrictionIntervalListRequest = (pointOfSaleGuid) => axios.get(RESTRICTION_INTERVAL_ENDPOINT(), { params: { point_of_sale__guid: pointOfSaleGuid } });
